import { Component, HostBinding, Input } from '@angular/core';
import { CorporateBadgeType } from './corporate-badge-type';
import { ExamBadgeType } from './exam-badge-type';
import { MembershipBadgeType } from './membership-badge-type';
import { PreferredFreelancerBadgeType } from './preferred-freelancer-badge-type';

export enum BadgeSize {
  SMALL = 'small',
  MID = 'mid',
  LARGE = 'large',
}

export enum BadgeType {
  CORPORATE = 'corporate',
  MEMBERSHIP = 'membership',
  EXAM = 'exam',
  PREFERRED_FREELANCER = 'preferred-freelancer',
}

export type Badge =
  | { type: BadgeType.CORPORATE; badge: CorporateBadgeType }
  | { type: BadgeType.MEMBERSHIP; badge: MembershipBadgeType }
  | { type: BadgeType.EXAM; badge: ExamBadgeType }
  | {
      type: BadgeType.PREFERRED_FREELANCER;
      badge: PreferredFreelancerBadgeType;
    };

@Component({
  selector: 'fl-badge',
  template: `
    <fl-picture
      class="BadgePicture"
      *ngIf="badge"
      [fullWidth]="true"
      [src]="'badges/' + badge.type + '/' + badge.badge"
      [alt]="badge.badge"
    ></fl-picture>
  `,
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent {
  @HostBinding('attr.data-size')
  @Input()
  size = BadgeSize.MID;

  @Input() badge: Badge;
}
